export default __webpack_public_path__ + "static/media/turkgot-screenshot-03.2eb1a483.png";